export default __webpack_public_path__ + "static/assets/977bfe8b16b324a91ee53ab61edf3430.svg";